module.exports = __webpack_public_path__ + "img/about-children-bg-2@mb.0ec2f26.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-children-bg-2@mb.png
// module id = kXlO
// module chunks = 2